import { render } from "./MasterAlatBeratForm.vue?vue&type=template&id=5d72ce65"
import script from "./MasterAlatBeratForm.vue?vue&type=script&lang=js"
export * from "./MasterAlatBeratForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__